import { Link } from 'react-router-dom'


interface HeroCallToActionSectionProps {
  title: string
  content: string
  buttonText: string
  buttonLink: string
  backgroundImage: string
}

const HeroCallToActionSection = ({ 
  title, 
  content, 
  buttonText, 
  buttonLink, 
  backgroundImage 
}: HeroCallToActionSectionProps) => {
  return (
    <section
      className="w-full relative"
      style={{
        height: '484px',
        paddingLeft: '64px',
        paddingRight: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src={backgroundImage}
        alt={title}
        className="w-full h-full object-cover"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: -1
        }}
      />
      <div className="w-full text-center">
        <h2
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: '32px',
            color: '#FFFFFF',
            fontWeight: '400',
            marginBottom: '32px',
            textAlign: 'center'
          }}
        >
          {title}
        </h2>
        
        <p
          style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif',
            fontSize: '16px',
            color: '#FFFFFF',
            lineHeight: '1.6',
            marginBottom: '32px',
            textAlign: 'center',
            maxWidth: '800px',
            margin: '0 auto 32px auto'
          }}
        >
          {content}
        </p>
        
        <Link
          to={buttonLink}
          style={{
            backgroundColor: '#FFFFFF',
            color: '#000000',
            fontFamily: 'Plus Jakarta Sans, sans-serif',
            fontSize: '16px',
            padding: '14px 36px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            textDecoration: 'none',
            display: 'inline-block'
          }}
        >
          {buttonText}
        </Link>
      </div>
    </section>
  )
}

export default HeroCallToActionSection